export const normalizeText = (text = "") =>
  text.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
